const Timeline = () => (
	<div>
		<h4>Timeline</h4>
		<p>Zoomable timeline for data with particular time stamp selection.</p>
	</div>
);

export default Timeline;
